import router from "../../../router";

export const token = (state,token) => {
    state.token = token
}

export const user = (state,user) => {
    state.user = user
    console.log(state.user)
    console.log(router)
}

export const baseurl = (state, url) => {
    state.baseurl = baseurl
}

export const onLogout = (state) => {
     state.token = null
     state.user = null
 }

 export const toogleConnecting = (state) => {
     state.connecting = !state.connecting
 }
 export const loginError = (state) => {
     state.loginError = true
 }

 export const initLoginError = (state) => {
     state.loginError = false
 }

 export const initConnecting = (state) => {
     state.connecting = false
 }

 export const uniqueOK = (state) => {
     state.uniqueOK = true
 }
 export const uniqueMailOK = (state) => {
     state.uniqueMailOK = true
 }

 export const uniqueNotOK = (state) => {
     state.uniqueOK = false
 }
 export const uniqueMailNotOK = (state) => {
     state.uniqueMailOK = false
 }

 export const checkingUnique = (state) => {
     state.checkingUnique = true
 } 
 export const checkingMailUnique = (state) => {
     state.checkingMailUnique = true
 }
 export const initCheckingUnique = (state) => {
     state.checkingUnique = false
 }

 export const initCheckingMailUnique = (state) => {
     state.checkingMailUnique = false
 }

 export const connecting = (state) => {
     state.connecting = true
 }